var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningFill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "6.1213mm",
    height: "7.6331mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 238.38 297.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_105553181203552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  }), /*#__PURE__*/React.createElement("g", {
    id: "background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flame"
  }), /*#__PURE__*/React.createElement("g", {
    id: "inactive_flame"
  }), /*#__PURE__*/React.createElement("g", {
    id: "streak_freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "streak_freeze_silhoutte"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lightning"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    fillRule: "nonzero",
    d: "M87.74 4.38l137.22 0c7.55,0 11.77,8.73 7.06,14.64l-83.59 105.03c-1.28,1.61 -1.04,3.94 0.53,5.26l32.66 27.31c5.66,4.73 5.86,13.34 0.44,18.34l-125.48 115.77c-5.74,5.3 -14.87,-0.04 -13.07,-7.64l24 -101.12c0.37,-1.57 -0.29,-3.19 -1.64,-4.06l-55.31 -35.53c-6.12,-3.94 -8.01,-12.03 -4.26,-18.26l66.94 -111.53c3.06,-5.11 8.56,-8.22 14.5,-8.22z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#FFEF99",
    strokeWidth: 8.76,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 77.4,
    y1: 42.71,
    x2: 88.96,
    y2: 23.44
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#FFEF99",
    strokeWidth: 8.76,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    x1: 67.7,
    y1: 58.86,
    x2: 68.68,
    y2: 57.23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBA700",
    fillRule: "nonzero",
    d: "M148.39 124c-1.24,1.65 -1.03,4.02 0.62,5.36l32.66 27.3c5.56,4.74 5.77,13.29 0.41,18.34l-125.49 115.71c-5.77,5.36 -14.84,0 -13.08,-7.62l4.12 -17.21c2.68,-0.93 5.15,-2.37 7.52,-4.53l93.66 -86.34c5.46,-5.05 5.25,-13.6 -0.41,-18.34l-32.66 -27.3c-1.65,-1.34 -1.85,-3.71 -0.51,-5.36l83.56 -104.99c4.74,-5.87 0.51,-14.63 -7.11,-14.63l33.28 0c7.62,0 11.74,8.76 7.11,14.63l-83.66 104.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.76,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M87.74 4.38l137.22 0c7.55,0 11.77,8.73 7.06,14.64l-83.59 105.03c-1.28,1.61 -1.04,3.94 0.53,5.26l32.66 27.31c5.66,4.73 5.86,13.34 0.44,18.34l-125.48 115.77c-5.74,5.3 -14.87,-0.04 -13.07,-7.64l24 -101.12c0.37,-1.57 -0.29,-3.19 -1.64,-4.06l-55.31 -35.53c-6.12,-3.94 -8.01,-12.03 -4.26,-18.26l66.94 -111.53c3.06,-5.11 8.56,-8.22 14.5,-8.22z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningFill2);
export default __webpack_public_path__ + "static/media/lightning-fill2.ca6e7096d6a07f21e8585acc7b0def09.svg";
export { ForwardRef as ReactComponent };